import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import _ from 'underscore';
import { GlobalService } from 'src/app/_services/global.service';
import { IframeSearchtoolboxserviceService } from 'src/app/_services/iframe-searchtoolboxservice.service';
import { environment } from 'src/environments/environment';


const devFrontendUrl = environment.frontendurl

@Component({
  selector: 'app-iframe-searchtoolbox',
  templateUrl: './iframe-searchtoolbox.component.html',
  styleUrls: ['./iframe-searchtoolbox.component.scss']
})
export class IframeSearchtoolboxComponent implements OnInit {
  totalSearchResultsCount: any;
  deselectedJobTitlesArray: any[] = [];
  deselectedSkillsArray: any[] = [];
  searchToolboxHistory: any;
  totalHistoryRecordsCount: any;
  total: any;
  start: number = 0;
  end: any;
  showSearchHistoryPage: boolean = false;
  showSearchPlatformPage: boolean = false;
  selectedPlatformType: string;
  tabToShow: string = 'LinkedIn';
  filteredInstituteOption: Array<any> = [];
  institute: string[] = [];
  filteredSpokenLanguageOption: Array<any> = [];
  spokenLanguage: string[] = [];
  filteredProgrammingLanguageOption: Array<any> = [];
  programmingLanguage: string[] = [];
  filteredEducationalDegreeOption: Array<any> = [];
  educationalDegree: string[] = [];
  showSearchResults: boolean = false;
  showResultsWithResume: boolean = false;
  filteredGenderOption: Array<any> = [];
  gender: string[] = [];
  functionNameForMoreResults: string;
  userSelectedData: any;
  showUserSelectedJobTitles: boolean = false;
  showUserSelectedPreferredSkills: boolean = false;
  showUserSelectedMandatorySkills: boolean = false;
  showUserSelectedLocations: boolean = false;
  showUserSelectedCompanies: boolean = false;
  showUserSelectedInstitutes: boolean = false;
  showUserSelectedGender: boolean = false;
  showUserSelectedEducationalDegrees: boolean = false;
  showUserSelectedIndustries: boolean = false;
  showUserSelectedSpokenLanguages: boolean = false;
  showUserSelectedProgrammingLanguages: boolean = false;
  showUserSelectedResumeOption: boolean = false;
  showFormError: boolean = false;
  jobtitlearraylist: Array<any> = [];
  skillsarraylist: Array<any> = [];
  industryarraylist: Array<any> = [];
  locationarraylist: Array<any> = [];
  companyarraylist: Array<any> = [];
  filteredJobTitleOptions: Array<any> = [];
  filteredSkillsOption: Array<any> = [];
  filteredIndustryOption: Array<any> = [];
  filteredLocationOption: Array<any> = [];
  filteredCompanyOption: Array<any> = [];
  jobtitle: string[] = [];
  industry: string[] = [];
  location: string[] = [];
  companies: string[] = [];
  preferredskills: string[] = [];
  mandatoryskills: string[] = [];
  recommendedjobtitle: any[] = [];
  recommendedskills: any[] = [];
  searchResults: any[] = [];
  startIndex: any;
  searchResultNextPage: any;
  viewingResultsFirstTime: boolean = false;
  currentPageTypeBeforeGoingToHistoryPage: string;

  @ViewChild('resultsSectionDiv') resultsSectionDiv: ElementRef;

  constructor(public searchtoolbox: IframeSearchtoolboxserviceService,) { }

  ngOnInit() { 
    window.onscroll = () => {
      const nav = document.querySelector('#mainNav');
      if(nav){
        if(scrollY <= 10) {
          nav.className = 'navbar navbar-expand-lg navbar-dark fixed-top text-white';
         }else{
           nav.className = 'navbar navbar-expand-lg navbar-dark fixed-top text-black  navbar-shrink bg-white border-bottom-nav';
         }
      }
    };
  }
 
  ngAfterViewChecked() {
    if (this.viewingResultsFirstTime && this.showSearchResults && !this.showSearchHistoryPage && this.resultsSectionDiv) {
      this.resultsSectionDiv.nativeElement.scrollIntoView(true);
    }
    this.viewingResultsFirstTime = false;
} 

  getAutoCompleteData(dropdowntype: any, searchedstring: any): Observable<any> {
    let data ={
      "dropdowntype": dropdowntype,
      "searchedstring": searchedstring
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        subject.next(res.data);
      }else{
        subject.next([])
      }
    })
    return subject.asObservable();
  }

  addSuggestionChipOnClickingEnter(event, type) {
    if (event.target.value && event.key == "Enter" && event.target.value.toString().trim().toLowerCase() != '') {
      event.target.value = event.target.value.toString().trim().toLowerCase()
      if (type == 'Job Title') {
        this.jobtitle.push(event.target.value);
        this.getRelatedData(type, event.target.value)
        event.target.value = ''
      } else if (type == 'Skill') {
        this.preferredskills.push(event.target.value);
        this.getRelatedData(type, event.target.value)
        event.target.value = ''
      } else if (type == 'Mandatory Skill') {
        this.mandatoryskills.push(event.target.value);
        this.getRelatedData('Skill', event.target.value)
        event.target.value = ''
      } else if (type == 'Location') {
        this.location.push(event.target.value);
        this.filteredLocationOption = []
        event.target.value = ''
      } else if (type == 'Company') {
          let companynameobj;
            companynameobj={
              company_name : event.target.value
            }
          this.companies.push(companynameobj)
          this.filteredCompanyOption = []
          event.target.value = ''
      } else if (type == 'Institute') {
        this.institute.push(event.target.value);
        this.filteredInstituteOption = []
        event.target.value = ''
      } else if (type == 'SpokenLanguage') {
        this.spokenLanguage.push(event.target.value);
        this.filteredSpokenLanguageOption = []
        event.target.value = ''
      } else if (type == 'ProgrammingLanguage') {
        this.programmingLanguage.push(event.target.value);
        this.filteredProgrammingLanguageOption = []
        event.target.value = ''
      } else if (type == 'Industry') {
        this.industry.push(event.target.value);
        this.filteredIndustryOption = []
        event.target.value = ''
      } else if (type == 'EducationalDegree') {
        this.educationalDegree.push(event.target.value);
        this.filteredEducationalDegreeOption = []
        event.target.value = ''
      } else if (type == 'Gender') {
        this.gender.push(event.target.value);
        this.filteredGenderOption = []
        event.target.value = ''
      }
    }
  }

  selectAutoCompleteChip(event, type) {
    if (type == 'Job Title') {
      this.getRelatedData(type, event)
    } else if (type == 'Skill') {
      this.getRelatedData(type, event)
    }
  }

  addRecommendedSuggestionChip(i, value, type) {
    value = value.toString().trim().toLowerCase()
    if (type == "Job Title") {
      this.recommendedjobtitle.splice(i, 1);
      this.jobtitle.push(value);
      this.getRelatedData(type, value)
    } else if (type == "Skill") {
      this.recommendedskills.splice(i, 1);
      this.preferredskills.push(value);
      this.getRelatedData(type, value)
    } else if (type == "Mandatory Skill") {
      this.recommendedskills.splice(i, 1);
      this.mandatoryskills.push(value);
      this.getRelatedData('Skill', value)
    }
  }

  getRelatedData(type: string, value: string , action?) {
    let data={
      searchparameter: type,
      searchedstring: value.toString().trim().toLowerCase(),
      selectedjobtitlesarray: this.jobtitle.filter((x)=>{return x != value}),
      selectedskillsarray : [...this.preferredskills, ...this.mandatoryskills].filter((x)=> {return x != value}),
      existingjobtitlessuggestionarray: this.recommendedjobtitle,
      existingskillssuggestionarray: this.recommendedskills,
      deselectedJobTitlesArray: this.deselectedJobTitlesArray,
      deselectedSkillsArray: this.deselectedSkillsArray
    }
    if(action == 'remove' && type == 'Job Title'){
      let selectedjob = data['selectedjobtitlesarray']
      data['searchedstring'] = selectedjob.length ? selectedjob[selectedjob.length - 1] : ''
      data['searchparameter'] = 'Job Title'
    }else if(action == 'remove' && type == 'Skill'){
      let selectedskill = data['selectedskillsarray']
      data['searchedstring'] = selectedskill.length ? selectedskill[selectedskill.length - 1] : ''
      data['searchparameter'] = 'Skill'
    }
    
    if (data.searchedstring.length) {
      this.searchtoolbox.recommendedData(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.recommendedjobtitle = res.data.related_job_titles
          this.recommendedskills = res.data.related_skills.filter((x)=> x)
          this.filteredJobTitleOptions = []
          this.filteredSkillsOption = []
        }
      });
    }
  }

  returnToLandingPage() {
    this.showSearchHistoryPage = false;
    this.showSearchPlatformPage = false;
    this.resetAllFields();
    this.hideAndResetSearchResults();
  }

  displayPlatformPage(platformType: string, platformName: string) {
    this.showSearchPlatformPage = true;
    this.selectedPlatformType = platformType;
    this.tabToShow = platformName;
  }


  pagination(type) {
    if (type == 'next') {
      this.start = this.start + 10
      this.end = this.start + 10
      if (this.end > this.total)
        this.end = this.total
    } else if (type == 'prev') {
      this.start = this.start - 10
      this.end = this.start + 10
    }
  }

  repeatSearch(data) {
    this.resetAllFields();
    this.jobtitle =  data.jobtitles ? data.jobtitles.split('; '): []
    this.location =  data.locations ? data.locations.split('; '): []
    this.mandatoryskills = data.mandatoryskills ?  data.mandatoryskills.split('; '): []
    this.preferredskills =  data.preferredskills ? data.preferredskills.split('; '): []
    let companies=  data.companies ? data.companies.split('; '): []
    this.industry=  data.industries ? _.pluck(data.industries, 'industry_name') : [];
    this.institute = data.schools ? data.schools.split('; '): []
    this.spokenLanguage = data.spokenlanguages ? data.spokenlanguages.split('; '): []
    this.programmingLanguage = data.programminglanguages ? data.programminglanguages.split('; '): []
    this.educationalDegree = data.educationaldegrees ? data.educationaldegrees.split('; '): []
    this.gender = data.gender ? data.gender.split('; '): []
    if(companies.length > 0){
      let companynameobj;
      companies.map(x =>{
        companynameobj={
          company_name : x
        }
        this.companies.push(companynameobj)
      })
    }
  
   let value;
   let searchedParameter;
   if(this.jobtitle && this.jobtitle.length){
    value = this.jobtitle[this.jobtitle.length - 1];
    searchedParameter = 'Job Title';
   } else if(this.preferredskills && this.preferredskills.length){
    value = this.preferredskills[this.preferredskills.length - 1];
    searchedParameter = 'Skill';
   } else if(this.mandatoryskills && this.mandatoryskills.length){
    value = this.mandatoryskills[this.mandatoryskills.length - 1];
    searchedParameter = 'Skill';
   }
   if(value){
    this.getRelatedData(searchedParameter, value)
   }

   // Show LinkedIn platform page in default condition
   if (data.searchtoolboxversion == 'v2.0') {
    this.tabToShow = data.platformsaccessed;
   } else {
     this.tabToShow = 'LinkedIn';
   }
   this.showSearchHistoryPage = false;
   this.selectedPlatformType = this.getPlatformType(this.tabToShow);
   this.showSearchPlatformPage = true;
  }

  resetAllFields() {
    this.jobtitle = []
    this.location = []
    this.companies = []
    this.industry = []
    this.preferredskills = []
    this.mandatoryskills = []
    this.recommendedjobtitle = []
    this.recommendedskills = [];
    this.start = 0
    this.institute = []
    this.spokenLanguage = [];
    this.programmingLanguage = [];
    this.educationalDegree = [];
    this.gender = [];
    this.hideAndResetSearchResults();
  }

  getPlatformType(platformName: string) {
    let platformType;
    switch(true) {
      case (platformName == 'LinkedIn' || platformName == 'Xing' || platformName == 'Quora' || platformName == 'Twitter'):
        platformType = 'General';
        break;
      case (platformName == 'AngelList' || platformName == 'Kaggle' || platformName == 'GitHub' || platformName == 'Stack Overflow' || platformName == 'ResearchGate'):
        platformType = 'Technical';
        break;
      case (platformName == 'Behance' || platformName == 'Dribbble'):
        platformType = 'Creative';
        break;
      case (platformName == 'Doximity' || platformName == 'HealthProfs'):
        platformType = 'Health Care';
        break
      default:
        break;
    }
    return platformType;
  }

  searchAutoCompletedData(event, type) {
    if(event.query.trim().toLowerCase()!=''){
      if (type == 'Job Title') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('job titles',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredJobTitleOptions  = res;
            }
          })
        }
      } else if (type == 'Skill') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('skills',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredSkillsOption  = res;
            }
          })
        }
      } else if (type == 'Industry') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('industries',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredIndustryOption = _.pluck(res, 'industry_name');
            }
          })
        }
      } else if (type == 'Location') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('locations',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredLocationOption  = res;
            }
          })
        }
      } else if (type == 'Company') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('companies',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredCompanyOption  = res;
            }
          })
        }
      } else if (type == 'Institute') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('institutes',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredInstituteOption  = res;
            }
          })
        }
      } else if (type == 'SpokenLanguage') {
        if (event.query.length > 0) {
          this.getAutoCompleteData('spoken languages',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredSpokenLanguageOption  = res;
            }
          })
        }
      } else if (type == 'ProgrammingLanguage') {
        if (event.query.length > 0) {
          this.getAutoCompleteData('programming languages',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredProgrammingLanguageOption  = res;
            }
          })
        }
      } else if (type == 'EducationalDegree') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('educational degrees',event.query).subscribe((res)=>{
            if (res && res.length) {
              this.filteredEducationalDegreeOption  = res;
            }
          })
        }
      } else if (type == 'Gender') {
        if (event.query.length > 0) {
          this.filteredGenderOption = ['Male', 'Female'];
        }
      }
    }
  }

  googleCustomSearchAPI(searchType: string, functionName?: string) {
    if (searchType == 'initial') {
      this.hideAndResetSearchResults();
    }

    // Validation: Minimum 1 preferred skill required
    if (this.preferredskills.length) {
      this.showFormError = false;

      this.userSelectedData = {};
      if (functionName) {
        this.functionNameForMoreResults = functionName
      }
      
      if (searchType == 'initial') {
        this.startIndex = 1
      } else if (searchType == 'nextPage' && (!functionName && this.functionNameForMoreResults)) {
        this.startIndex = this.startIndex + 10;
      }
  
      this.userSelectedData = {
        startindex: this.startIndex,
        usernumber: "2de27442-0d80-41aa-a37e-4887164b1ef2"
      };
      if (this.jobtitle.length) {
        this.userSelectedData['jobtitles'] = this.jobtitle;
      }
      if (this.preferredskills.length) {
        this.userSelectedData['preferredskills'] = this.preferredskills;
      }
      if (this.mandatoryskills.length) {
        this.userSelectedData['mandatoryskills'] = this.mandatoryskills;
      }
      if (this.location.length) {
        this.userSelectedData['locations'] = this.location;
      }
      if (this.companies.length) {
        this.userSelectedData['companies'] =  _.pluck(this.companies, 'company_name');
      }
      if (this.spokenLanguage.length) {
        this.userSelectedData['spokenlanguages'] = this.spokenLanguage;
      }
      if (this.institute.length) {
        this.userSelectedData['schools'] = this.institute;
      }
      if (this.industry.length) {
        this.userSelectedData['industries'] = this.industry;
      }
      if (this.programmingLanguage.length) {
        this.userSelectedData['programminglanguages'] = this.programmingLanguage;
      }
      if (this.educationalDegree.length) {
        this.userSelectedData['educationaldegrees'] = this.educationalDegree;
      }
      if (this.showResultsWithResume) {
        this.userSelectedData['resumecheckbox'] = 1;
      }
      if (this.gender.length) {
        this.userSelectedData['gender'] = this.gender;
      }
      
      this.searchtoolbox[this.functionNameForMoreResults](this.userSelectedData).subscribe((res: any) => {
        if (res.status == 'success') {
          let tempresults = []
          tempresults = res.data.searchResults
          this.searchResultNextPage = res.data.nextSearchPagePresent
          this.totalSearchResultsCount = res.data.totalResults
          if(this.totalSearchResultsCount > 0){
            this.searchResults = [...this.searchResults,...tempresults]
          }
  
          // Show user selected options based on current platform
          if (this.userSelectedData.jobtitles && this.tabToShow != 'GitHub') {
            this.showUserSelectedJobTitles = true;
          }
          if (this.userSelectedData.preferredskills) {
            this.showUserSelectedPreferredSkills = true;
          }
          if (this.userSelectedData.mandatoryskills) {
            this.showUserSelectedMandatorySkills = true;
          }
          if (this.userSelectedData.locations && this.selectedPlatformType != 'Doximity' && this.selectedPlatformType != 'HealthProfs') {
            this.showUserSelectedLocations = true;
          }
          if (this.userSelectedData.companies && (this.tabToShow == 'LinkedIn' || this.selectedPlatformType == 'General')) {
            this.showUserSelectedCompanies = true;
          }
          if (this.userSelectedData.spokenlanguages && this.tabToShow == 'LinkedIn') {
            this.showUserSelectedSpokenLanguages = true;
          }
          if (this.userSelectedData.schools && (this.tabToShow == 'LinkedIn' || this.tabToShow == 'ResearchGate')) {
            this.showUserSelectedInstitutes = true;
          }
          if (this.userSelectedData.industries && (this.tabToShow == 'LinkedIn' || this.tabToShow == 'Xing')) {
            this.showUserSelectedIndustries = true;
          }
          if (this.userSelectedData.programminglanguages && this.tabToShow == 'GitHub') {
            this.showUserSelectedProgrammingLanguages = true;
          }
          if (this.userSelectedData.educationaldegrees && (this.tabToShow == 'ResearchGate' || this.tabToShow == 'Doximity')) {
            this.showUserSelectedEducationalDegrees = true;
          }
          if (this.userSelectedData.resumecheckbox && this.userSelectedData.resumecheckbox == 1 && this.tabToShow == 'Behance') {
            this.showUserSelectedResumeOption= true;
          }
          if (this.userSelectedData.gender && this.tabToShow == 'Doximity') {
            this.showUserSelectedGender = true;
          }
  
          this.showSearchResults = true; 
          document.getElementById('resultsSectionDiv').scrollIntoView();
          this.viewingResultsFirstTime = true;
        }
      })
    } else {
        this.showFormError = true;
    }
  }

  showResumeCheckbox(event) {
    this.showResultsWithResume = event.target.checked;
  }

  removeSelectedChip(event,type){
    if (type == 'Job Title' && this.deselectedJobTitlesArray.indexOf(event) == -1) {
      this.deselectedJobTitlesArray.push(event)
       this.getRelatedData(type, event , 'remove')
     } else if (type == 'Skill' && this.deselectedSkillsArray.indexOf(event) == -1) {
      this.deselectedSkillsArray.push(event)
       this.getRelatedData(type, event, 'remove')
     }
   }

  updateTabToShow(platformType: string, platformName: string) {
     this.tabToShow = platformName;
     this.selectedPlatformType = platformType;
     this.hideAndResetSearchResults();
   }

  hideAndResetSearchResults() {
    this.showSearchResults = false;
    this.searchResults = [];
    this.searchResultNextPage = undefined;
    this.totalSearchResultsCount = undefined;
    this.showFormError = false;
    this.showUserSelectedJobTitles = false;
    this.showUserSelectedPreferredSkills = false;
    this.showUserSelectedMandatorySkills = false;
    this.showUserSelectedLocations = false;
    this.showUserSelectedCompanies = false;
    this.showUserSelectedInstitutes = false;
    this.showUserSelectedGender = false;
    this.showUserSelectedEducationalDegrees = false;
    this.showUserSelectedIndustries = false;
    this.showUserSelectedSpokenLanguages = false;
    this.showUserSelectedProgrammingLanguages = false;
    this.showUserSelectedResumeOption = false;
  }

   goBackFromHistoryPage() {
    this.showSearchHistoryPage = false;
    if (this.currentPageTypeBeforeGoingToHistoryPage == 'platformPage') {
      this.showSearchPlatformPage = true;
    } else if (this.currentPageTypeBeforeGoingToHistoryPage == 'landingPage') {
      this.showSearchPlatformPage = false;
      this.resetAllFields();
      this.hideAndResetSearchResults();
    }
  }

  route2store(){
    window.open('https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm', "_blank");
  }

  Redirect2signup(){
    window.open(devFrontendUrl + '/signup/?ref=public-search-toolbox', "_blank");
  }

}


